
const MemberForm = (props) => {
	return (
		<div>
			{props.isTeam ? <h4 className="mt-8 mb-4 pt-8 text-2xl text-center font-bold border-t">Team Member {props.number}</h4> : null}

			<div className="mb-4">
				<label htmlFor={`Name-${props.number}`} className="block font-medium mb-2">Full Name*</label>
				<input
					type="text"
					id={`Name-${props.number}`}
					name={`Name-${props.number}`}
					placeholder="Your Name *"
					className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3"
					required
				/>
			</div>

			<div className="mb-4">
				<label htmlFor={`Department-${props.number}`} className="font-medium">Department*</label>
				<select name={`Department-${props.number}`} className="mt-1 text-black border-gray-300 shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border rounded-sm">
					<option value="CSE" id="CSE">CSE</option>
					<option value="ME" id="ME">ME</option>
					<option value="EEE" id="EEE">EEE</option>
					<option value="ECE" id="ECE">ECE</option>
					<option value="CE" id="CE">CE</option>
					<option value="IT" id="IT">IT</option>
					<option value="AEI" id="AEI">AEI</option>
					<option value="AIDS" id="AIDS">AIDS</option>
					<option value="CSBS" id="CSBS">CSBS</option>
				</select>
			</div>

			<div className="mb-2">
				<label htmlFor={`Division-${props.number}`} className="block font-medium mb-2">Division*</label>
				<div className="flex items-center">
					<input
						type="radio"
						id="Alpha"
						value="Alpha"
						name={`Division-${props.number}`}
						className="m-2 ml-0 w-6 h-6"
					/>
					<label htmlFor="Alpha" className="block font-medium mr-4 md:mr-6">Alpha</label>
					<input
						type="radio"
						id="Beta"
						value="Beta"
						name={`Division-${props.number}`}
						className="m-2 w-6 h-6"
					/>
					<label htmlFor="Beta" className="block font-medium mr-4 md:mr-6">Beta</label>
					<input
						type="radio"
						id="Gamma"
						value="Gamma"
						name={`Division-${props.number}`}
						className="m-2 w-6 h-6"
					/>
					<label htmlFor="Gamma" className="block font-medium mr-4 md:mr-6">Gamma</label>
					<input
						type="radio"
						id="None"
						value="None"
						name={`Division-${props.number}`}
						className="m-2 w-6 h-6"
					/>
					<label htmlFor="None" className="block font-medium">None</label>
				</div>
			</div>

			<div className="mb-4">
				<label htmlFor={`Uid-${props.number}`} className="text-sm font-medium">Uid*</label>
				<input type="text" id={`Uid-${props.number}`} name={`Uid-${props.number}`} placeholder="Uid*" onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()} className="mt-1 uppercase text-black border-gray-300 shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border rounded-sm" />
			</div>

			<div className="mb-4 flex flex-col">
				<label htmlFor={`Semester-${props.number}`} className="text-sm font-medium">Semester*</label>
				<select name={`Semester-${props.number}`} className="mt-1 text-black border-gray-300 shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border rounded-sm">
					<option value="S2" id="S2">S2</option>
					<option value="S4" id="S4">S4</option>
					<option value="S6" id="S6">S6</option>
					<option value="S8" id="S8">S8</option>
				</select>
			</div>
		</div>
	);
}

export default MemberForm;